import React, { Component } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { decodeEntities } from '../../util/helpers';
import './SubscribeBlock.scss';

const FACEBOOK_TYPE = 'Facebook';
const INSTAGRAM_TYPE = 'Instagram';

export default class SubscribeForm extends Component {
  state = {
    email: '',
    errorMessage: null,
    submitting: false,
    submitSuccess: false,
    submitError: false,
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { email, submitting } = this.state;
    if (submitting) return false;
    this.setState({
      submitting: true,
      submitSuccess: false,
      submitError: false,
    });
    const result = await addToMailchimp(email);
    if (result.result === 'success') {
      this.setState({
        submitSuccess: true,
        submitting: false,
      });
    } else {
      this.setState({
        errorMessage: decodeEntities(result.msg),
        submitError: true,
        submitting: false,
      });
    }
  }

  handleChange = (event) => {
    this.setState({
      email: event.target.value,
    });
  }

  isAlreadySubscribed = () => {
    const { errorMessage } = this.state;
    return errorMessage.indexOf('already subscribed') || errorMessage.indexOf('too many requests');
  }

  render() {
    const {
      socialLinks
    } = this.props;
    const {
      email,
      submitting,
      submitSuccess,
      submitError,
    } = this.state;
    const facebookLink = socialLinks.find(link => link.type === FACEBOOK_TYPE);
    const instagramLink = socialLinks.find(link => link.type === INSTAGRAM_TYPE);
    return (
      <div className="subscribe-form-block">
        <div className={`form-container ${submitSuccess ? 'submit-success' : ''}`}>
          <div className="inner-container">
            { submitSuccess && (
              <div className="success-message">
                <span className="title">Nice one! You’re on the list.</span>
                <span className="subtitle">You'll be the first to know next time publish a new story.</span>
                <a
                  className="nav-item"
                  href={instagramLink.link.url}
                  aria-label="Navigate to our Instagram profile"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span>Instagram</span>
                  <svg className="arrow" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                  </svg>
                </a>
                <a
                  className="nav-item"
                  href={facebookLink.link.url}
                  aria-label="Navigate to our Facebook profile"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span>Facebook</span>
                  <svg className="arrow" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                  </svg>
                </a>
              </div>
            )}
            { !submitSuccess && (
              <>
                <div className="sign-up-message">
                  <span className="title">More stories are in the making.</span>
                  <span className="subtitle">Want to see more? Subscribe my to my newsletter to get the news stories delivered to your inbox</span>
                </div>
                <form
                  className="subscribe-form"
                  name="subscribe"
                  onSubmit={event => this.handleSubmit(event)}
                >
                  <label htmlFor="email" className={`field full-width ${submitError ? 'has-error' : ''}`} aria-label="Email">
                    <span>Your email</span>
                    <input
                      type="email"
                      id="email"
                      disabled={submitting}
                      name="email"
                      placeholder="hello@email.com"
                      onChange={event => this.handleChange(event)}
                      value={email}
                      required
                    />
                    <div className="error-message">
                      <span>{this.isAlreadySubscribed ? 'Looks like you\'re already subscribed to our mailing list.' : `Uh oh! Something went wrong!`}</span>
                    </div>
                  </label>
                  <button className={`submit-button styled-button ${submitting ? 'submitting' : ''}`} aria-label="Send" type="submit" disabled={submitting}>
                    <span className="label">{submitting ? 'Submitting...' : 'Sign up'}</span>
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}
